import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/helpers/common.service';

@Component({
  selector: 'app-s-platform',
  templateUrl: './s-platform.component.html',
  styleUrls: ['./s-platform.component.scss'],
})
export class SPlatformComponent implements OnInit {
  providerInfo: any;

  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    this.getData();
  }

  async getData() {
    try {
      this.commonService.onLoaderChange.next(true);
      this.providerInfo = await this.commonService.getHtmlTemplate({ route: 'service_platform' });
      this.commonService.onLoaderChange.next(false);
    } catch (error) {
      console.error(error);
      this.commonService.onLoaderChange.next(false);
    }
  }
}
